import { render, staticRenderFns } from "./SingleThreat.vue?vue&type=template&id=58171403&"
import script from "./SingleThreat.vue?vue&type=script&lang=ts&"
export * from "./SingleThreat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports